/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\ConnexionRow\ConnexionRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday December 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday December 11th 2023 2:15:50 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { TableCell, TableRow } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { ConnexionRowProps } from "Type/Connextion.type";
import { memo } from "react";
import { FaDotCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

function ConnexionRow(props: ConnexionRowProps & {displayName: boolean}) {
    const tmpDate = new Date(props.Date);

    return (
        <TableRow hover>
            <TableCell align="center"><FaDotCircle color={props.Status === "SUCCESS" ? "green" : "red"}/></TableCell>
            <TableCell align="center" className="text-capitalize">{tmpDate.toLocaleDateString()} {tmpDate.toLocaleTimeString()}</TableCell>
            <TableCell align="center" className="text-capitalize">{props.Company}</TableCell>
            {
                props.displayName ?
                <>
                    <TableCell align="center" className="text-capitalize">
                        <Link to={RouterPathResolver.pathUser_BY_ID.path.replace(":id", props.userID)}>
                            {props.LastName} {props.FirstName}
                        </Link>
                    </TableCell>
                    <TableCell align="center">
                        <Link to={RouterPathResolver.pathUser_BY_ID.path.replace(":id", props.userID)}>
                            {props.Email}
                        </Link>
                    </TableCell>
                </>
                :null
            }
            <TableCell align="center" className="text-capitalize">{props.IP}</TableCell>
            <TableCell align="center" className="text-capitalize">{props.From}</TableCell>
            <TableCell align="center" className="text-capitalize">{props.Commercial.FirstName} {props.Commercial.LastName}</TableCell>
        </TableRow>
    );
}

export default memo(ConnexionRow);
